import { useState } from 'react';
import client from '../api/client';
import SocialLinks from '../components/Global/SocialLinks';
import { useBlog } from '../context/BlogContext';
import Spinner from '../components/Global/Spinner';
import { useAlert } from '../context/AlertContext';
import footerNavigation from './footerNavigation';
import seo from '../data';
import { Link } from 'react-router-dom';

export default function Footer2() {
	const { setAlert } = useAlert();
	const { titles, loading } = useBlog();
	const [formData, setFormData] = useState({});
	const handleChange = (e) => {
		e.preventDefault();
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			const res = await client.post('/customer', {
				email: formData.email,
			});
			if (res) {
				setFormData({});
				setAlert('success', 'Thank you for subscribing!');
			}
		} catch (error) {
			console.error(error);
			return setAlert('error', 'Error subscribing. Please try again.');
		}
	};

	return (
		<footer
			className='bg-secondary'
			aria-labelledby='footer-heading'
		>
			<h2
				id='footer-heading'
				className='sr-only'
			>
				Footer
			</h2>

			<div className='mx-auto max-w-7xl px-6 pb-8 pt-20 sm:pt-24 lg:px-8 lg:pt-32'>
				<div className='grid grid-cols-1 md:grid-cols-2 gap-8 items-baseline'>
					{/* Email Form Column */}
					<div className='my-16 xl:mt-0'>
						<h3 className='text-sm font-semibold leading-6 text-gray-100'>
							Subscribe to our newsletter
						</h3>
						<p className='mt-2 text-sm leading-6 text-gray-100'>
							The latest news, articles, and resources, sent to your inbox weekly.
						</p>
						<form
							className='mt-6 sm:flex sm:max-w-md'
							onSubmit={handleSubmit}
						>
							<label
								htmlFor='email'
								className='sr-only'
							>
								Email address
							</label>
							<input
								type='email'
								name='email'
								onChange={handleChange}
								id='email-footer'
								autoComplete='email'
								value={formData.email || ''}
								required
								className='w-full min-w-0 appearance-none rounded-md border-0 bg-white px-3 py-1.5 text-base text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:w-64 sm:text-sm sm:leading-6 xl:w-full'
								placeholder='Enter your email'
							/>
							<div className='mt-4 sm:ml-4 sm:mt-0 sm:flex-shrink-0'>
								<button
									type='submit'
									className='flex w-full items-center justify-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600'
								>
									Subscribe
								</button>
							</div>
						</form>
					</div>
					{/* Links Column */}
					<div className='grid grid-cols-2 gap-8'>
						{/* Company */}
						<div>
							<h3 className='text-sm font-semibold leading-6 text-gray-100'>Company</h3>
							<ul
								role='list'
								className='mt-6 space-y-4'
							>
								{footerNavigation.company.map((item) => (
									<li key={item.name}>
										<Link
											to={item.href}
											className='text-sm leading-6 text-gray-300 hover:text-gray-50'
										>
											{item.name}
										</Link>
									</li>
								))}
							</ul>
						</div>

						{/* Legal */}
						<div>
							<h3 className='text-sm font-semibold leading-6 text-gray-100'>Legal</h3>
							{loading ? (
								<Spinner />
							) : (
								<ul
									role='list'
									className='mt-6 space-y-4'
								>
									{footerNavigation.legal.map((item) => (
										<li key={item.name}>
											<Link
												to={item.href}
												className='text-sm leading-6 text-gray-300 hover:text-gray-50'
											>
												{item.name}
											</Link>
										</li>
									))}
								</ul>
							)}
						</div>
					</div>
				</div>

				<div className='mt-16 border-t border-gray-100/10 pt-8 sm:mt-20 md:flex md:items-center md:justify-between lg:mt-24'>
					<p className='text-xs leading-5 text-gray-300 md:order-1 md:mt-0'>
						&copy; {new Date().getFullYear()} {seo.companyName}. All rights reserved.
					</p>
					<div className='flex space-x-6 md:order-2'>
						<SocialLinks footer={true} />
					</div>
				</div>
			</div>
		</footer>
	);
}
